import type { KehrblattCaseCommunicationAutomationContext } from "../../../../../../../../api/kehrblatt/case-communications"
import type { ContactOrderStep } from "../../../../../../../../api/kehrblatt/contact-orders"
import { resolveWerkAdminOrigin } from "./systemDomains"

const normalizeString = (value: unknown) => {
  if (value === null || value === undefined) return null

  const text = typeof value === "string" ? value : String(value)
  const trimmed = text.trim()

  return trimmed ? trimmed : null
}

export const resolveWerkAdminContextForStep = ({
  step,
  automationContext,
  organizationSlug,
}: {
  step?: ContactOrderStep | null
  automationContext?: KehrblattCaseCommunicationAutomationContext | null
  organizationSlug?: string | null
}) => {
  return {
    channel: step?.channel ?? "",
    sessionId: normalizeString(automationContext?.session_id),
    orgSlug:
      normalizeString(automationContext?.organization_slug) ?? normalizeString(organizationSlug),
    projectId: normalizeString(automationContext?.project_ref),
    realization: normalizeString(automationContext?.realization_ref),
  }
}

export const buildWerkAdminSessionUrl = (
  sessionId?: string | null,
  orgSlug?: string | null,
  projectId?: string | null,
  realizationRef?: string | null,
) => {
  if (!sessionId) return null

  const werkAdminBase = resolveWerkAdminOrigin().replace(/\/+$/, "")
  const suffix = `/admin/sessions/${encodeURIComponent(sessionId)}/evaluation?channel=voice&fullscreen=true`

  if (orgSlug && projectId && realizationRef) {
    return `${werkAdminBase}/organizations/${encodeURIComponent(orgSlug)}/projects/${encodeURIComponent(projectId)}/realization/${encodeURIComponent(realizationRef)}${suffix}`
  }

  return `${werkAdminBase}${suffix}`
}

export const buildWerkAdminNewSessionUrl = (
  orgSlug?: string | null,
  projectId?: string | null,
  realizationRef?: string | null,
) => {
  const werkAdminBase = resolveWerkAdminOrigin().replace(/\/+$/, "")
  const suffix = "/admin/sessions/new/eventviewer?channel=voice&fullscreen=true"

  if (orgSlug && projectId && realizationRef) {
    return `${werkAdminBase}/organizations/${encodeURIComponent(orgSlug)}/projects/${encodeURIComponent(projectId)}/realization/${encodeURIComponent(realizationRef)}${suffix}`
  }

  return `${werkAdminBase}${suffix}`
}

export const resolveWerkAdminTarget = ({
  step,
  automationContext,
  organizationSlug,
}: {
  step?: ContactOrderStep | null
  automationContext?: KehrblattCaseCommunicationAutomationContext | null
  organizationSlug?: string | null
}) => {
  const ctx = resolveWerkAdminContextForStep({ step, automationContext, organizationSlug })
  const sessionUrl = buildWerkAdminSessionUrl(
    ctx.sessionId,
    ctx.orgSlug,
    ctx.projectId,
    ctx.realization,
  )
  const fallbackUrl = buildWerkAdminNewSessionUrl(ctx.orgSlug, ctx.projectId, ctx.realization)

  return {
    sessionUrl,
    fallbackUrl,
  }
}
